import { Moment } from "moment";
import { useEffect, useState } from "react";
import { useAppContext } from "../../libs/app-core/AppContext";
import { OnApiError } from "../ErrorManager";
import { UniQuestion } from "./UniQuestion";
import { DAO } from "./DAO";
import { API, ApiResult } from "./API";
import { WS } from "./WS";

export class UniQuestionDAO {


  static async Insert_新增空白題目(uni_form_guid: string): Promise<UniQuestion> {
    let data = new UniQuestion();

    data.form_guid = uni_form_guid;

    let refetch_data = await DAO.Insert(UniQuestion, data);
    return refetch_data;
  }


  /** 修改指定欄位，DGV修改數值用 */
  static async UpdateOneField(find_data: UniQuestion, field: string, value: any): Promise<UniQuestion> {

    console.log("WWWW: ", field);

    if (field === "question_code" || field === "ch_his_code" || field === "q_his_code") {
      value = (value as string).trim();// code 系列 自動先 trim(); 
    }

    (find_data as any)[field] = value;

    let re = await DAO.UpdateOnly(UniQuestion, find_data, [field]);

    return re;
  }

  static async Update_SetSortNo(data: UniQuestion, sort_no: number): Promise<UniQuestion> {
    data.sort_no = sort_no;
    let re = await DAO.UpdateOnly(UniQuestion, data, ["sort_no"]);
    return re;
  }



  static async Delete(data: UniQuestion): Promise<number> {
    let effect_rows_cnt = await DAO.DeleteByGuid(UniQuestion, data.guid);
    return effect_rows_cnt;
  }

  static async FetchByGuid(guid: string): Promise<UniQuestion> {
    let data = await DAO.FetchByGuid(UniQuestion, guid);
    return data;
  }

  static async Select(uni_form_guid: string | null): Promise<UniQuestion[]> {
    let cond = " WHERE (1=1) "
      + " AND " + Cnd.指定所屬主檔(uni_form_guid)
      + Cnd.OrderBy預設排序();

    let data_list = await DAO.Select(UniQuestion, cond);
    return data_list;
  }

  static async WS_SelectQuestions_ByFormGuidList(form_guid_list: string[] | null | undefined): Promise<UniQuestion[]> {
    let api_rslt: ApiResult = await WS.CallWS(
      "uni_question/select_by_form_guid_list",
      { form_guid_list: form_guid_list }
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassList(UniQuestion, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }


}

class Cnd {

  static 指定所屬主檔(form_guid: string | null) {
    return ` (form_guid='${form_guid}') `;
  }

  static OrderBy預設排序() {
    return ` ORDER BY sort_no, serno `;
  }

  static 指定特做版本(form_guid: string | null) {
    return ` (form_guid='${form_guid}') `;
  }

  static 指定所屬特作(form_guid_list: string[] | null | undefined) {
    if (form_guid_list == null) {
      return " (1=0) ";
    } else {
      let ary: any[] = [];

      form_guid_list?.forEach((guid: string) => {
        ary.push(`form_guid='${guid}'`)
      })

      return ary.join(' OR ');
    }
  }
}


export function useUniQuestion(guid: string) {
  const ctx = useAppContext();

  const [_UniQuestion, set_UniQuestion] = useState<UniQuestion | null>(null);

  async function refresh_UniQuestion() {
    try {
      const data_list = await UniQuestionDAO.FetchByGuid(guid);
      set_UniQuestion(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_UniQuestion();
  }, [guid]);

  return { _UniQuestion, set_UniQuestion, refresh_UniQuestion }
}


export function useUniQuestionList(form_guid: string) {
  const ctx = useAppContext();

  const [_UniQuestionList, set_UniQuestionList] = useState<UniQuestion[] | undefined>(undefined);

  async function refresh_UniQuestionList() {
    try {
      const data_list = await UniQuestionDAO.Select(form_guid);
      set_UniQuestionList(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_UniQuestionList();
  }, [form_guid]);

  return { _UniQuestionList, set_UniQuestionList, refresh_UniQuestionList }
}